export default "/images/subscription.svg?1c9dfd94d37381e9985ec2a709362dd6";